"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AsyncStorageKey = void 0;
exports.getTokensAsync = getTokensAsync;
exports.getValueFromAsyncStorage = getValueFromAsyncStorage;
exports.removeItemForKey = removeItemForKey;
exports.saveValueToAsyncStorage = saveValueToAsyncStorage;
exports.setGuestTokensDataAsync = setGuestTokensDataAsync;
exports.setTokensDataAsync = setTokensDataAsync;
var _asyncStorage = _interopRequireDefault(require("@react-native-async-storage/async-storage"));
async function saveValueToAsyncStorage(key, value) {
  try {
    await _asyncStorage.default.setItem(key, value);
  } catch (e) {
    return null;
  }
}
async function getValueFromAsyncStorage(key) {
  try {
    return await _asyncStorage.default.getItem(key);
  } catch (e) {
    return null;
  }
}
async function removeItemForKey(key) {
  try {
    return await _asyncStorage.default.removeItem(key);
  } catch (e) {
    return null;
  }
}
const AsyncStorageKey = exports.AsyncStorageKey = {
  tokenType: 'tokenType',
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  idToken: 'idToken',
  expiresOn: 'expiresOn',
  currentUserAsterId: 'currentUserAsterId',
  showDashboardPopup: 'showDashboardPopup',
  guestToken: 'guestToken',
  deviceId: 'deviceId',
  platform: 'platform'
};
async function setGuestTokensDataAsync(response) {
  await Promise.all([saveValueToAsyncStorage(AsyncStorageKey.guestToken, response.accessToken)]);
}
async function setTokensDataAsync(response) {
  await Promise.all([saveValueToAsyncStorage(AsyncStorageKey.tokenType, response.token_type), saveValueToAsyncStorage(AsyncStorageKey.accessToken, response.access_token), saveValueToAsyncStorage(AsyncStorageKey.refreshToken, response.refresh_token), saveValueToAsyncStorage(AsyncStorageKey.idToken, response.id_token), saveValueToAsyncStorage(AsyncStorageKey.expiresOn, response.expires_in.toString())]);
}
async function getTokensAsync() {
  const [tokenType, accessToken, refreshToken, idToken, expiresOn] = await Promise.all([getValueFromAsyncStorage(AsyncStorageKey.tokenType), getValueFromAsyncStorage(AsyncStorageKey.accessToken), getValueFromAsyncStorage(AsyncStorageKey.refreshToken), getValueFromAsyncStorage(AsyncStorageKey.idToken), getValueFromAsyncStorage(AsyncStorageKey.expiresOn)]);
  return {
    tokenType,
    accessToken,
    idToken,
    refreshToken,
    expiresOn: parseInt(expiresOn)
  };
}